import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 0,

  title: 'Transfusion',
  description: 'Blood transfusion to a patient',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    dueTime: types.DATE_TIME_INDEX,
    status: types.STRING_INDEX, // task
    details: types.STRING,

    bloodProductType: types.OBJECT,
    bloodProduct: types.OBJECT,
    patient: types.OBJECT,
    hospital: types.OBJECT,

    consumables: types.ARRAY,
    equipments: types.ARRAY,
    healthCareWorkers: types.ARRAY,

    // Audit fields
    ...auditFields
  },

  required: ['id', 'dueTime', 'status', 'bloodProductType', 'patient', 'hospital'],
  indexes: [
    ['dueTime'],
    ['status']
  ],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
